/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { useLayoutEffect } from 'react';

var useResizeTable = function useResizeTable(hooks) {
  var useInstanceBeforeDimensions = function useInstanceBeforeDimensions(instance) {
    var rootRef = instance.rootRef,
        handleResize = instance.handleResize;
    var parent = rootRef && rootRef.current && rootRef.current.parentElement;
    useLayoutEffect(function () {
      if (!parent) {
        return function () {};
      }

      handleResize();

      if (typeof ResizeObserver === 'function') {
        var resizeObserver = new ResizeObserver(function () {
          handleResize();
        });
        resizeObserver.observe(parent);
        return function () {
          resizeObserver.disconnect(parent);
          resizeObserver = null;
        };
      }

      return console.error(' Could not resize table, no support for ResizeObserver');
    }, [handleResize, parent]);
  };

  hooks.useInstanceBeforeDimensions.push(useInstanceBeforeDimensions);
};

export default useResizeTable;